module.exports = __webpack_public_path__ + "5c277052df304c3d317361f2044a0b20.pdf";